import React, { Component, FC, useState } from "react";
import { ICellRendererParams, GetContextMenuItemsParams } from "ag-grid-community";
import { InfoOutlined, MoreVert } from "@mui/icons-material";
import Button from "@mui/material/Button";
//import ErrorOutlinedIcon from "@mui/icons-material/ErrorOutlined";
import AccountTeamDialog from "components/portfolio/components/AccountTeamDialog";
import { renderToString } from "react-dom/server";
import ErrorOutlinedIcon from "@mui/icons-material/ErrorOutlined";
import { AuthDetail } from "types/auth";
import { FEATURE_KEY } from "constant";
import { trackButton } from "utils";
import NoteDialog from "components/summary/index/Note/NoteDialog";
import ContactDialog from "components/summary/index/Contact/ContactDialog";
import Tooltip from "@mui/material/Tooltip";
import { lightTheme } from "theme";
import { createRoot } from "react-dom/client";
import { ThemeProvider, Theme, StyledEngineProvider } from "@mui/material/styles";

declare module "@mui/styles/defaultTheme" {
  // eslint-disable-next-line
  interface DefaultTheme extends Theme {}
}

const isClick = false;

class CheckboxCell extends Component<
  ICellRendererParams & { hideMenu?: boolean },
  {
    isClick: boolean;
    accountTeamDialog: { authDetail: AuthDetail; account: any } | null;
  }
> {
  constructor(props: ICellRendererParams) {
    super(props);
    this.state = {
      isClick,
      accountTeamDialog: null,
    };
    (this.props.node as any)._checkboxCell = this;
  }

  handleClick(e: any) {
    const event = new MouseEvent("contextmenu", e);
    e.target.dispatchEvent(event);
  }

  openAccountTeamDialog = (authDetail: AuthDetail, account: any) => {
    this.setState({ accountTeamDialog: { authDetail, account } });
  };

  render() {
    // fix theme issue
    return (
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={lightTheme}>
          {this.props.node.rowPinned ? (
            this.props.data.status ? (
              <span
                style={{
                  color: "#898989",
                  fontSize: "12px",
                  fontWeight: 500,
                }}
              >
                {this.props.data.status}
              </span>
            ) : (
              <div style={{ display: "flex", alignItems: "center" }}>
                <span
                  style={{
                    color: "#333",
                    fontSize: "12px",
                    fontWeight: 500,
                  }}
                >
                  Total
                </span>
                <Tooltip
                  title={
                    <p>
                      Not including 'Pending Provisioning' because for change replace subscription
                      on current 'Active' accounts will double the ARR (Active + PP)
                    </p>
                  }
                  arrow={true}
                  placement="top"
                >
                  <InfoOutlined
                    style={{
                      marginLeft: 4,
                      color: "#000000",
                      fillOpacity: 0.4,
                      fontSize: "1rem",
                    }}
                  />
                </Tooltip>
              </div>
            )
          ) : !this.props.hideMenu ? (
            <Button
              style={{ padding: "0", minWidth: "auto" }}
              onClick={this.handleClick}
            >
              <MoreVert style={{ color: "#009ECB" }} />
            </Button>
          ) : null}
          {this.state.accountTeamDialog && (
            <AccountTeamDialog
              open={!!this.state.accountTeamDialog}
              authDetail={this.state.accountTeamDialog.authDetail}
              account={this.state.accountTeamDialog.account}
              dialogClose={() => this.setState({ accountTeamDialog: null })}
            />
          )}
        </ThemeProvider>
      </StyledEngineProvider>
    );
  }
}

const WrapDialog: FC<{
  type: string;
  accountId?: string;
  accountKey?: string;
  from: string;
}> = ({ type, accountId, accountKey, from }) => {
  const [open, setOpen] = useState(true);
  const onClose = () => {
    setOpen(false);
  };
  return type === "note" ? (
    <NoteDialog
      open={open}
      onClose={onClose}
      type="Add New"
      accountId={accountId}
      from="Quick Link"
      page={from}
    />
  ) : (
    <ContactDialog
      open={open}
      data={{}}
      onClose={onClose}
      type="Add New"
      accountKey={accountKey}
      accountId={accountId}
      from="Quick Link"
      page={from}
    />
  );
};

export function getCheckboxContextMenu(
  params: GetContextMenuItemsParams,
  authDetail: AuthDetail,
  type: string
) {
  const i = params.node.data;
  const { accountId, confidential, accountStatus, accountKey } = i;
  let usageArray = [
    {
      title: "Meeting",
      authKey: "meetingUsage",
      component: {
        name: "View Meetings Usage",
        action: () => {
          const url = `/spng/summary/usage/meeting?accountId=${accountId}`;
          window.open(url, "_blank");
          trackButton(`Quick Link Meetings`);
        },
      },
    },
    {
      title: "Messaging",
      authKey: "teamsUsage",
      confidential: true,
      component: {
        name: "View Messaging Usage",
        action: () => {
          const url = `/spng/summary/usage/teams?accountId=${accountId}`;
          window.open(url, "_blank");
          trackButton(`Quick Link Messaging`);
        },
      },
    },
    {
      title: "Calling",
      authKey: "calling",
      confidential: true,
      component: {
        name: "View Calling Usage",
        action: () => {
          const url = `/spng/summary/usage/calling?accountId=${accountId}`;
          window.open(url, "_blank");
          trackButton(`Quick Link calling`);
        },
        tooltip: "",
      },
    },
    {
      title: "Meeting Host",
      authKey: "hostUsage",
      component: {
        name: "View Meeting Host Usage",
        action: () => {
          const url = `/spng/summary/usage/host?accountId=${accountId}`;
          window.open(url, "_blank");
          trackButton(`Quick Link Meeting Host`);
        },
      },
    },
  ];
  usageArray = usageArray.filter((item) => {
    const isShowItem = authDetail?.menus.some((m) => m === item.authKey);
    if (isShowItem && confidential && item.confidential) {
      item.component.name = renderToString(
        <div
          style={{
            cursor: "not-allowed",
            color: "#B2B2B2",
          }}
        >
          {item.component.name}
        </div>
      );
      item.component.tooltip =
        "Data is not available for customers (accounts) with Webex Site(s) in Cluster 'F' (FedRAMP).";
      item.component.action = () => null;
    }
    return isShowItem;
  });

  const canViewCiscoAccountTeam = authDetail.features.includes(FEATURE_KEY.PORTFOLIO_ACCOUNT_TEAM);
  const canViewContact =
    accountStatus === "Active" &&
    authDetail.features.includes(FEATURE_KEY.VIEW_SUMMARY_CONTACT_ACTION_COLUMN);
  const canViewNote =
    accountStatus === "Active" && authDetail.features.includes(FEATURE_KEY.EDIT_NOTE);
  const canViewActivity = authDetail.features.includes(FEATURE_KEY.VIEW_ACTIVITY);
  const viewActivity = {
    name: "View Activity",
    action: () => {
      const url = `/spng/summary/activity?accountId=${accountId}`;
      window.open(url, "_blank");
    },
  };
  const viewCiscoAccountTeam = {
    name:
      "View Cisco Account Team" +
      renderToString(
        <ErrorOutlinedIcon
          style={{
            fontSize: "1em",
            color: "#009ECB",
            marginLeft: "4px",
            verticalAlign: "text-top",
          }}
        />
      ),
    tooltip:
      "Account team (Sales) associated to the customer based on Customer Registry (CR) Party ID",
    action: () => {
      (params.node as any)._checkboxCell?.openAccountTeamDialog(authDetail, i);
    },
  };

  const viewAddNote = {
    name: "Add a Note",
    action: () => {
      const wrapper = document.createElement("div");
      document.body.appendChild(wrapper);
      const xx = createRoot(wrapper);
      xx.render(
        <WrapDialog
          type={"note"}
          accountId={accountId}
          from={type}
        />
      );
      trackButton(`Quick Link Add a Note`);
    },
  };

  const viewAddContact = {
    name: "Add a Contact",
    action: () => {
      const wrapper = document.createElement("div");
      document.body.appendChild(wrapper);
      const xx = createRoot(wrapper);
      xx.render(
        <WrapDialog
          type={"contact"}
          accountId={accountId}
          accountKey={accountKey}
          from={type}
        />
      );
      trackButton(`Quick Link Add a Contact`);
    },
  };

  const usageAuthArray: any = [
    type.includes("portfolio") && canViewNote ? viewAddNote : null,
    type.includes("portfolio") && canViewContact ? viewAddContact : null,
    type === "portfolio_only" && canViewActivity ? viewActivity : null,
    canViewCiscoAccountTeam ? viewCiscoAccountTeam : null,
  ];
  usageArray.forEach((usageObj) => usageAuthArray.push(usageObj.component));
  return usageAuthArray;
}

export default CheckboxCell;
